<div class="language-selector-container">
  <h1 data-qa="language-selector-title">
    {{ 'header.languageSelector.header' | transloco }}
  </h1>
  <button
    #closeButton
    class="btn btn-close-modal"
    type="button"
    tabindex="0"
    [attr.aria-label]="'textToSpeech.close' | transloco"
    (click)="closeModal()"
    [attr.aria-label]="'common.close' | transloco"
  >
    <img
      src="assets/images/misc/close.svg"
      alt="{{ 'common.close' | transloco }}"
    />
  </button>
  @if (baseSites$ | async; as baseSites) {
    <ul
      class="language-selector-list-container"
      role="listbox"
      aria-labelledby="language-selector-title"
    >
      @for (baseSite of baseSites; track trackByUid($index, baseSite)) {
        <li class="language-selector" role="option">
          <boels-language-selector-modal-item
            [baseSite]="baseSite"
            (baseSiteLanguageEventEmitter)="setBoelsBaseSiteLanguage($event)"
          >
          </boels-language-selector-modal-item>
        </li>
      }
    </ul>
  }
</div>
